<template>
  <div class="checkout">
    <div class="space"></div>
    <h2 class="featured-title">{{ $t('checkout.chkt.title') }}</h2>

    <b-row>
      <b-col md="6" class="mb-3">
        <b-card bg-variant="light" class="text-left">
          <b-row class="mb-3">
            <b-col cols="12" lg="7" xl="8">
              <h4>{{$t('checkout.chkt.shipDet')}}</h4>
            </b-col>
            <b-col cols="12" lg="5" xl="4">
              <a @click="gotoAccountManagement()">
                <font-awesome-icon icon="plus"/>&nbsp;&nbsp;
                {{ $t('checkout.shipDet.newAddr') }}
              </a>
            </b-col>
          </b-row>
          <shipping-detail @selected="addressSelected"/>
        </b-card>
      </b-col>
      <b-col md="6">
        <b-card bg-variant="light" :title="$t('checkout.chkt.order')" class="text-left">
          <order-detail ref="orderDetail"/>
        </b-card>
      </b-col>
    </b-row>

    <div class="bottom-space"></div>
    <div class="checkout-button">
      <div v-if="isSessionActive">
        <div
          v-if="emailConfirmed && carts.length > 0"
        >
          <b-button
            size="lg"
            class="full-width primary-button"
            @click="handleCheckout()"
          >
            {{ $t('checkout.chkt.gotoPayment') }}
          </b-button>
          <br />
          <br />
        </div>
        <div v-else-if="!emailConfirmed">
          <p>{{ $t('checkout.chkt.cantCheckout') }}</p>
          <b-button
            class="primary-button"
            @click="resendEmailConfirmation()"
          >
            {{ $t('checkout.chkt.resendEmailConfirm') }}
          </b-button>
        </div>
      </div>
      <div v-else>
        <p>
          {{ $t('checkout.chkt.loginFirst') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import ShippingDetail from '@/components/checkout/ShippingDetail.vue';
import OrderDetail from '@/components/checkout/OrderDetail.vue';
import ProxyUrls from '@/constants/ProxyUrls';
import { mapGetters } from 'vuex';
import notification from '@/services/notificationService';

export default {
  name: 'Checkout',
  components: {
    ShippingDetail,
    OrderDetail,
  },

  data() {
    return {
      selectedAddressId: null,
    };
  },

  async created() {
    await this.$store.commit('cartStore/resetCheckoutData');
    await this.$store.dispatch('cartStore/getCart');
  },

  methods: {

    async addressSelected(addr) {
      this.selectedAddressId = addr;
    },

    gotoAccountManagement() {
      this.$router.push({name:'account', params: {subcomp: 'addresses'}});
    },

    async handleCheckout() {
      try {
        // Validate that theres an address selected
        if (!this.selectedAddressId) {
          notification.warn(this, this.$t('checkout.chkt.emptyAddrErrMsg'));
          return;
        }

        // Validate that there's at least one item selected for checkout
        if(!this.$refs.orderDetail.getHasItemsSelectedForCheckout()) {
          notification.warn(this, this.$t('checkout.chkt.noItemsSelectedErr'));
          return;
        }

        // Create checkout session and store important data retrieved by response
        await this.$store.dispatch(
          'cartStore/createCheckoutSession',
          { selectedAddressId: this.selectedAddressId }
        );

        // Verify that important data is stored in vuex store
        if(this.checkoutId === null || this.stripeClientSecret === null) {
          throw new Error("Failed while setting checkout");
        }

        // Goto stripe checkout, important data will be managed by vuex store
        this.$router.push('/payment-process/' + this.checkoutId);
      }
      catch (err) {
        this.$notify({
          group: 'all',
          type: 'error',
          text: this.$t('checkout.chkt.checkoutSessionErr'),
        });

        // Get cart again for the case that some products are not available anymore
        await this.$store.commit('cartStore/getCart');
      }
    },

    async resendEmailConfirmation() {
      try {
        const { data } = await this.$axios({
          method: 'get',
          url: ProxyUrls.resendEmailConfirmation + this.$store.getters['authStore/getEmail'],
        });

        if (data && data.httpStatus === 200) {
          this.$notify({
            group: 'all',
            type: 'success',
            text: this.$t('checkout.chkt.resendOk'),
          });
        }
      } catch (err) {
        this.$notify({
          group: 'all',
          type: 'error',
          text: this.$t('checkout.chkt.resendErr'),
        });
      }
    },
  },

  computed: {
    ...mapGetters({
      carts: 'cartStore/getCart',
      isSessionActive: 'authStore/isSessionActive',
      emailConfirmed: 'authStore/emailConfirmed',
      checkoutId: 'cartStore/checkoutId',
      stripeClientSecret: 'cartStore/stripeClientSecret'
    }),
  },
};
</script>

<style lang="scss">
.checkout {
  padding: 0rem 2rem;
  margin-bottom: 10px;
  padding-bottom: 3rem;
  min-height: 90vh;
  position: relative;
  background-color: #eaecee;

  .bottom-space {
    height: 40px;
  }

  .checkout-button {
    margin-top: 20px;
    padding: 0rem 2rem;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
  }
}
</style>
